export default {
  namespaced: true,
  state: {
    needSave: false,
  },
  mutations: {
    STOP_NEED_SAVE(state) {
      state.needSave = false;
    },
    START_NEED_SAVE(state) {
      state.needSave = true;
    },
  },
  actions: {
    startNeedSave({ commit }) {
      commit('START_NEED_SAVE');
    },
    stopNeedSave({ commit }) {
      commit('STOP_NEED_SAVE');
    },
  },
};
